module.exports = __webpack_public_path__ + "static/media/thumbnail.25a1bc52.png";